import { App } from 'map-feature-info'
import { useDispatch } from 'react-redux'

import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { useMapDataWithAggregateProperties } from '~map-preview/hooks/useMapDataWithAggregateProperties'
import { useTitleProperty } from '~map-preview/states/map'
import {
  closeMapFeatureInfoDrawer,
  useIsMapFeatureInfoDrawerOpen
} from '~map-preview/states/ui'

const MapFeatureInfoDrawer = () => {
  const dispatch = useDispatch()

  const isEmbed = useIsEmbed()
  const map = useMapDataWithAggregateProperties()
  const open = useIsMapFeatureInfoDrawerOpen()
  const title = useTitleProperty()

  const handleClose = () => {
    dispatch(closeMapFeatureInfoDrawer())
  }

  return (
    <App
      isEmbed={isEmbed}
      title={title?.name || 'Name'}
      map={map}
      open={open}
      onClose={handleClose}
    />
  )
}

export { MapFeatureInfoDrawer }
